import React, { useEffect, useState } from "react";
import { Box, Divider, Grid2,Typography } from "@mui/material";
import ScreenContainer from "../../Components/ScreenContainer";
import Events from "../../Analytics/Events";
import { getPagesMetaData } from "../../Api/Api";
import CODE from "../../Static/Constants/StatusCodes";
import ResourceOnboardingMain from "../../PagesContent/ResourceOnboarding/ResourceOnboardingMain";

const ResourceOnboarding = () => {

    const [pagesContent, setPagesContent] = useState({mounted: false});

    async function getPageMeta() {
        const pageName = 'ResourceOnboarding'
        const res = await getPagesMetaData(pageName)
        Events("Resource Onboarding page opened");

        if (res && res?.responseStatus?.code === CODE.SUCCESS) {
            const pageData = res.response?.response?.metaInfo
            setPagesContent({
                ...pagesContent,
                metaInfo: pageData,
                mounted: true
            })
        }
    }

    useEffect(() => { getPageMeta(); }, []);

    return (
        <ScreenContainer pagesContent={pagesContent}>
            <Box sx={{px: 3, pt: 3, pb: 2}}>
                <Typography variant="fw500s20c000000" sx={{fontSize: '24px', lineHeight: '24px'}}>Data Upload</Typography>
            </Box>
            <Divider orientation="horizontal" flexItem sx={{ borderColor: "#E4E4E4"}} />
            <ResourceOnboardingMain />
        </ScreenContainer>
    );
}

export default ResourceOnboarding;
